<template>
<div class="app flex-row align-items-center">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-4">
        <div class="card-group mb-0">
          <div class="card p-4">
            <div class="card-body">
              <form v-on:submit="doLogin" action="#">
                <h3>{{ appName }}</h3>
                <p class="text-muted">Bem vindo ao {{appName}}, para aceder à sua conta utilize o formulário abaixo.</p>
                <b-form-group>
                  <b-input-group>
                    <b-input-group-text slot="prepend"><i class="fa fa-user"></i></b-input-group-text>
                    <b-form-input  name="username"  placeholder="Nome de utilizador" v-model="username" />
                  </b-input-group>
                </b-form-group>
                <b-form-group>
                  <b-input-group>
                    <b-input-group-text slot="prepend"><i class="fa fa-key"></i></b-input-group-text>
                    <b-form-input  type="password" placeholder="Palavra-passe" v-model="password" />
                  </b-input-group>
                </b-form-group>
                <div class="row">
                  <div class="col-6">
                    <router-link :to="{name: 'Home'}">Esqueceu-se da palavra-passe?</router-link>
                  </div>
                  <div class="col-6 text-right">
                    <button :disabled="working" type="submit" class="btn  btn-primary px-4">Login</button>
                  </div>
                </div>

              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'Login',
  data() {
    return {
      appName: 'Inpar',
      working: false,
      username: '',
      password: ''
    }
  },
  methods: {
    doLogin(event) {
      this.working = true
      event.preventDefault()
      var redirect = this.$auth.redirect()
      var redirectTo = {name: 'dashboard'}
      if (redirect) {
        redirectTo = redirect.from
      }
      this.$auth.login({
        data: {
          username: this.username,
          password: this.password
        },
        redirect: redirectTo,
        success: function(response) {
          this.$bvToast.toast(`Login efetuado com sucesso`, { autoHideDelay: 5000, variant: 'success', solid: true })
        },
        error: function(response) {
          this.working = false
          this.$bvToast.toast(`Nome de utilizador ou palavra-passe incorrectos`, { autoHideDelay: 5000, variant: 'danger', solid: true })
        }
      })
    }
  },
  created() {
    if (typeof Window.appConfig !== 'undefined' && Window.appConfig.name) {
      this.appName = Window.appConfig.name
    }
  }
}
</script>
